import React from 'react';
import Navigation from './NavigationSimple';
import FloatingCapture from './FloatingCapture';
import { useAuth } from '../contexts/AuthContext';

export default function AppLayout({ children, title, actions, noPadding = false }) {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-background">
      <Navigation />

      <main className="lg:pl-64 pb-20 lg:pb-0 min-h-screen">
        {title && (
          <div className="sticky top-safe-header z-20 glass border-b border-[#1C1C1C]/60">
            <div className="grid grid-cols-layout gap-4 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="col-span-12 flex items-center justify-between h-14 lg:h-16">
                <h1 className="font-heading text-lg lg:text-xl font-semibold text-white tracking-tight">{title}</h1>
                {actions && <div className="flex items-center gap-2">{actions}</div>}
              </div>
            </div>
          </div>
        )}

        <div className={noPadding ? '' : 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8'}>
          {children}
        </div>
      </main>

      {user && <FloatingCapture />}
    </div>
  );
}
